<template>
    <Sidebar v-if="$store.state.user_data"/>
    <Content class="creator-list-content">
        <Loading class="static static-back" v-show="is_loading || $store.state.is_loading"/>

        <div class="inner inner-box" v-if="(!$store.state.is_loading && !is_loading) && (data.length > 0 || ( data.length === 0 && !is_empty_data)) && can_see_pro">
            <Header @create="createPro"/>

            <div class="applic-data-wrap" >

                <header class="top">
                    <div class="left">
                        <Dropdown v-if="!is_loading" :items="filterList" :icon_direction_type="'right'" class="dropdown-status"
                        :default_value="filter_value[0].index" @update-dropdown="updateFilter" />

                        <Dropdown :items="programs" :disabled="programs.length === 0" class="dropdown-programs"
                        @update-dropdown="updateProgram" :is_update_index="true"
                        :default_value="0"
                        :is_select_dropdown="true" /> 
                    </div>
                    <div class="ui-search">
                        <Search @onenter="search" :placeholder_text="'Search by program name, URL, or tag'"/>
                    </div>
                    <div class="right">
                        <Dropdown :items="select_pagenum" @update-dropdown="updatePagenum" :default_id="sort.per_page"/>
                        <Pagenavi :page_current="sort.current_page" :page_total="sort.total_page"
                            @goto-page="gotoPage" />
                    </div>
                </header>
                <Scrollbar :class="['data-list', (editValue && now_pick_key < 7 && data.length <= 5 ) && 'data-list-open-scroll']" :show_bar="true">
                    <Table :style="top" :class="{ 'is-loading': is_loading_data }">
                        <template #head>
                  
                                <TableTh :name="'name'" :title="'Application Title'" :sort_value="sort"
                                            @sort="sortFun" :content="'Application Title'" />

                                <TableTh :name="'status'" :title="'Status'" :sort_value="sort"
                                @sort="sortFun" :content="'Status'" />

                                <!-- <th><span>Social(s)</span></th> -->
                                <TableTh :name="'approved'" :title="'Approved'" :sort_value="sort"
                                @sort="sortFun" :content="'Approved'" />
                                <TableTh :name="'todo'" :title="'To-Do'" :sort_value="sort"
                                @sort="sortFun" :content="'To-Do'" />
                                <TableTh :name="'waitlist'" :title="'Waitlist'" :sort_value="sort"
                                @sort="sortFun" :content="'Waitlist'" />
                                <TableTh :name="'candidates'" :title="'Candidates'" :sort_value="sort"
                                @sort="sortFun" :content="'Candidates'" />
                                <TableTh :name="'application_start'" :title="'Application Period'" :sort_value="sort"
                                @sort="sortFun" :content="'Application Period'" />
                                <TableTh :name="'program_tag'" :title="'Application Tag'" :sort_value="sort"
                                @sort="sortFun" :content="'Applicants approved to activate storefronts will be automatically labeled with this tag, viewable in the Creator Management dashboard.'" />
                                <th></th>
                                <th></th>
                                <!-- <th></th> -->
                    
                        </template>

                        <template #body>
                            
                            <template v-if="!is_loading && !$store.state.is_loading && data.length === 0 && !is_empty_data">
                                <tr>
                                    <td colspan="13">
                                        <NoData />
                                    </td>
                                </tr>
                            </template>

                            <tr v-for="(row, index) in data" :key="index" @click="open(row)" :class="['status-' + row.status_name]">

                                <td class="name td">
                                    <div class="title">
                                        <tippy :content="row.title"
                                            @mouseover="isEllipsisActive($event, row)">
                                            {{ row.title }}
                                        </tippy>
                                    </div>
                                    <tippy :content="row.url"
                                        @mouseover="isEllipsisActive($event, row)">
                                        <a :href="row.url" target="_blank">{{ row.url }}</a>
                                    </tippy>
                                </td>
                                <td class="badage td">
                                    <Badage :value="row.stateValue.text" :type="row.stateValue.color" />
                                </td>
                                <td class="value td" v-for="(v, k) in row.list" :key="k">
                                    <!-- <div class="v-title">{{v.name}}</div> -->
                                    <div class="v-value" style="justify-content: unset;">
                                        <span v-if="v.value === '---'" class="none">---</span>
                                        <span v-else-if="v.value === '--- (0%)'" class="none">--- (0%)</span>
                                        <span v-else>{{v.value}}</span>
                                        <span class="v-is-new" v-if="v.new && v.new!=='---'"><svg-icon name="plus"/>{{v.new}}</span>
                                    </div>
                                </td>
                                <td class="value td">
                                    <div class="v-value">{{ row.period }}</div>
                                </td>
                                <td class="value tag-td td">
                                    <tippy :content="row.tag" @mouseover="isEllipsisActive($event, row)">
                                        <Badage :value="row.tag" :type="'gray'" />
                                    </tippy>
                                </td>
                                <td class="item-btn td">
                                    <Button v-if="row.btn === 'Responses' && permission_recruitment.manageCandidates.permission !==0 "
                                        class="res-btn" color="black-60" size="24"  :style="'border-square'"
                                        @click.stop="listPick(row.status,row)">{{row.btn}}</Button>
                                    <div class="pick-list"></div>
                                </td>
                                <!-- <td class="item td" @click.stop="goOutsidePage(row)">
                                    <svg-icon v-if="row.status === 100" name="eye" />
                                </td> -->
                                <td :class="['item td three-td', $store.state.merchant_disabeld && 'disabeld-box']" @click.stop="pickEdit(row,index)">
                                    <svg-icon name="menu" />
                                    <!-- style="editListTopText" 是為了底下的row打開不要掉下去  -->
                                    <div class="editList" v-if="editValue && now_pick_row.ambassador_application_id === row.ambassador_application_id" :style="editListTopText" ref="el">
                                        <div class="item" v-for="(item, index) in editList" :key="index" @click.stop="selectType(item.id,index)">
                                            <span :class="[item.id===8 &&'red']">{{ item.text }}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        
                    </Table>
                </Scrollbar>
            </div>
        </div>

        <!-- empty-list -->
        <Empty @create="createPro" v-if="(data.length === 0 && is_empty_data || !can_see_pro) && !$store.state.is_loading && !is_loading">
            <Header :had_programs="false"/>
        </Empty>
    </Content>

    <AddProgramPop ref="add" @save="goOpenSet"/>
    <FormSetting />

    <Modal :is_show="is_show_add_modal" class="add-creator-modal" @click-bg="is_show_add_modal = false">
        <header>Add Creators <i @click="is_show_add_modal = false"><svg-icon name="close" /></i></header>
    </Modal>

    <Modal :is_show="is_show_del_modal" class="alert-modal" @click-bg="is_show_del_modal = false">
        <div class="box">
            <header class="delete-header">Delete application?</header>
            <p>You will lose access to all candidate information and responses if you choose to delete this application. You can stop accepting submissions in your Applications dashboard.</p>
            <div class="btns">
                <Button type="button" :border_r="6" color="white" size="32"
                    @click.native="is_show_del_modal = false">Don't delete</Button>
                <Button class="modal-del-btn" type="button" :border_r="6" color="dark-blue" size="32" @click.native="isDel()">Delete</Button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_error_modal" class="alert-modal" @click-bg="is_show_error_modal = false">
        <div class="box">
            <header class="delete-header">Submission error</header>
            <p>Please review and complete the required field(s):</p>
            <ul style="margin: 16px 16px 16px 24px; color: var(--black-60)">
                <li style="list-style: disc;" v-for="(item, index) in error_messages" :key="index">{{ item.message }}</li>
            </ul>
            
            <div class="btns">
                <Button type="button" :border_r="6" color="dark-blue" size="32" @click.native="is_show_error_modal = false; $store.state.is_loading = true; openFormSetting(null, 'edit', error_id)">Edit application</Button>
            </div>
        </div>
    </Modal>

    <ApplicationPublishModal ref="pub_modal" :url="current_app_url" />
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Modal from '@/components/ui/Modal.vue';
import Header from '@/components/programs/ApplicationsListHeader.vue';
import Badage from '@/components/ui/Badage.vue';
import Table from '@/components/ui/Table.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Empty from '@/components/programs/ApplicationsListEmpty.vue';
import AddProgramPop from '@/components/programs/AddProgramPop.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import GetStartedText from '@/components/creator/GetStartedText.vue';
import FormSetting from '@/components/programs/Form/FormSetting.vue';
import TableTh from '@/components/ui/TableTh.vue';
import Search from '@/components/ui/Search.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import moment from 'moment';
import { HandleKNum,HandleNum,HandleNumSpec } from '@/utils/SwitchFun';
import { Temp_App_Data,appDropList1,appDropList2,appDropList3,FilterList } from '@/utils/ProgramsData.js';
import ApplicationPublishModal from '@/components/programs/ApplicationPublishModal.vue';

export default {
    name: 'Programs - List',

    data() {
        return {
            is_loading: true,
            is_loading_data: false,
            is_show_add_modal: false,
            is_show_delete_modal: false,
            is_show_error_modal: false,
            // is_show_pub_modal: true,
            error_messages: [],
            error_id: 0,
            current_app_url: '',
            data: [],
            filter_value:[
                {
                    field_name:'program_status',
                    value:'',
                    index:0,
                },
                {
                    field_name:'program_tag',
                    value:'',
                }
            ],
            sort:{
                sort_key: '',
                sort_val: 'desc',
                page: 1,
                per_page: 50,
                search_keyword:'',
                current_page:1,
                total_page: 1,
            },
            select_pagenum: [
                { id: 50, text: '50/page' },
                { id: 20, text: '20/page' },
            ],
            programs: [
                { id: 1, text: 'All', is_selected: true },
            ],
            editValue:false,
            editList:[],
            editListTop:0,
            editListTopText:'',
            filterList:FilterList,
            top: '--top: 0px',
            now_pick_row:{},
            now_pick_key:null,
            is_show_del_modal:false,
            is_user_filter:false,//上方操作時會讓data操控瞬間為0，導致UI體感不好，這邊做handle
        }
    },

    computed: {
        //在沒任何條件篩選下真的空的Data
        is_empty_data(){
            let tval=true;
            tval=!this.filter_value[0].value && !this.filter_value[1].value && !this.sort.search_keyword && !this.sort.sort_key && !this.is_user_filter ? true: false;
            return tval;
        },

        can_see_pro(){
            let user_d=this.$store.state.user_data;
            return user_d && user_d.merchant_account && user_d.merchant_account.is_enable_ambassador_program;
        },

        permission_recruitment(){
            return this.$store.state.user_data?.permission_list?.recruitment;
        },

    },

    components: {
        Sidebar,
        Button,
        Content,
        Badage,
        Scrollbar,
        Modal,
        Header,
        Table,
        NoData,
        Loading,
        Dropdown,
        GetStartedText,
        Empty,
        AddProgramPop,
        FormSetting,
        TableTh,
        ApplicationPublishModal,
        Search,
        Pagenavi,
    },

    watch: {
        '$route.params': {
            handler() {
                this.data = [];
                this.is_loading = true;

                this.fetchData();
                this.getTags();
            },
            immediate: true,
        }
    },

    methods: {
        HandleKNum:HandleKNum,

        open(row) {
            if (row.status_name !== 'draft' && this.permission_recruitment.manageCandidates.permission !==0 ) this.$router.push(`/programs/application/${row.ambassador_application_id}`);
        },


        isEllipsisActive(e, row) {
            row.is_ellipsis_active = (e.target.offsetWidth < e.target.scrollWidth);
        },

        handleClick(e) {
            // if (this.$refs.el && !this.$refs.el.contains(e.target)) {
            //     this.editValue=false;
            // }
            const elements = this.$refs.el;
            let isOutside = true;

            // 確保 $refs.el 是一個陣列（由 v-for 生成）
            if (Array.isArray(elements)) {
                for (let el of elements) {
                    if (el.contains(e.target)) {
                        isOutside = false;
                        break;
                    }
                }
            } 

            if (isOutside) {
                this.editValue = false;
            }
        },

        pickEdit(row,key){
         
            if(row.status===50){
                this.editList=appDropList2;
            }else if(row.status===0){
                this.editList=appDropList3;
            }else{
                this.editList=appDropList1;
            }

            //-------permission
            if(!this.permission_recruitment?.editApplicationSettings?.permission){
                this.editList=this.editList.filter(item => item.id === 1 || item.id === 5);
            };
            //----------------

            this.editValue= this.now_pick_key === key && this.editValue ? false:true;//控制開關
            this.now_pick_row=row;
            this.now_pick_key=key;
            
            if(key<=3){
                this.editListTop= 32;
                this.editListTopText= `top:${this.editListTop}px`;
            }else{           
                this.editListTop= 20;
                this.editListTopText= `bottom:${this.editListTop}px`;
            }
          
            
        },

        openFormSetting(data,type,id,is_preview){
            this.$store.state.program_data.create_data=data;
            this.$store.state.program_data.is_preview= is_preview? true:false;
            this.$router.push(`/programs/application/${type}/${id}`);
        },

        listPick(status,row){
            // console.log(status ,row)

            if(status===50){
                this.openFormSetting(null,'edit',row.ambassador_application_id)
            }else{
                this.open(row)
            }
        },

        selectType(id,index){


            this.editValue=false;
            let aId=this.now_pick_row.ambassador_application_id;

            if(id===1){
               this.toPreview();
            }

            else if(id===2){
                window.open(this.now_pick_row.url, "_blank");
            }
            //edit
            else if(id===3){
                this.$store.state.is_loading=true;
                this.openFormSetting(null,'edit',aId)
            }
            //copy(not use)
            else if(id===4){
                this.$store.state.is_loading=true;
            }
            //share
            else if(id===5){
                const obj = {};
                obj.storefront_url = this.now_pick_row.url;
                this.EventBus.emit('open-share', obj);
            }
            //unpublished
            else if(id===6){
                this.$store.state.is_loading=true;
                this.$ajax(`/ambassador/unpublished-application`, {
                    method: 'post',
                    data:{
                        application_id:aId,
                    },
                }).then(res => {
                    this.is_user_filter=true;
                    this.fetchData();
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Unpublish success!`);
                    this.$store.state.is_loading=false;
                }).catch(err=>{
                    this.handleErrMes(err);
                }); 
            }
            //published
            else if(id === 7){
                this.publishApplication(aId);
            }
            //del
            else if(id===8){
                //this.is_show_del_modal=true;
                //目前只有草稿在這裡可以刪除，所以就不提示警告
                this.isDel();
            }
            //rePublish
            else if(id===9){
                this.$store.state.is_loading=true;
                this.$ajax(`/ambassador/republish-application`, {
                    method: 'post',
                    data:{
                        application_id:aId,
                    },
                }).then(res => {
                    this.is_user_filter=true;
                    this.fetchData();
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Republish success!`);
                    this.$store.state.is_loading=false;
                }).catch(err=>{
                    this.handleErrMes(err);
                }); 
            }
        },

        isDel(){
            this.$store.state.is_loading=true;
            let aId=this.now_pick_row.ambassador_application_id;
            this.$ajax(`/ambassador/delete-application`, {
                method: 'post',
                data:{
                    application_id:aId,
                },
            }).then(res => {
                let indexToRemove = this.data.findIndex((item)=> {
                    return item.ambassador_application_id === this.now_pick_row.ambassador_application_id;
                });
                this.data.splice(indexToRemove, 1);
                this.$store.state.is_loading=false;
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Delete Success!`);
            }).catch(err=>{
                this.handleErrMes(err);
            });  
        },

        publishApplication(aId){
            
            this.$store.state.is_loading=true;
            this.$ajax(`/ambassador/publish-application`, {
                method: 'post',
                data:{
                    application_id: aId,
                },
            }).then(res => {
                this.is_user_filter = true;
                this.current_app_url = this.data.find(item => item.ambassador_application_id === aId).url;
                this.fetchData();
                // this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Publish success!`);
                this.$store.state.is_loading = false;
                // this.is_show_pub_modal = true;
                this.$refs.pub_modal.open();

            }).catch(err => {
                this.$store.state.is_loading = false;
                // console.log(err.response.data.data.message);
                this.is_show_error_modal = true;
                this.error_id = aId;
                this.error_messages = err.response.data.data.message;

                // this.handleErrMes(err);
            }); 
        },

        handleErrMes(err){
            if(err.response && err.response.data &&err.response.data.message){
                this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> ${err.response.data.message}!`);
            }
            else if(err.response && err.response.data && err.response.data.data &&err.response.data.data.message){
                this.$notify(`<svg> class="err-notify"<use xlink:href="#alert--sprite"></use></svg> ${err.response.data.data.message}!`);
            }
            this.$store.state.is_loading=false;
        },

        toPreview(){
            this.$store.state.is_loading=true;
            this.openFormSetting(null,'edit',this.now_pick_row.ambassador_application_id,'preview');
        },

        resetSort(){
            this.sort.sort_key = '';
            this.sort.sort_val = 'desc';
        },

        //data handle
        search(keyword) {
            this.resetSort();
            this.is_user_filter=true;
            this.sort.search_keyword = keyword;
            this.fetchData();
        },

        updateFilter(val){
            this.is_user_filter=true;
            this.resetSort();
            this.filter_value[0].value=val.key;
            this.filter_value[0].index=val.index_key;
            this.fetchData();
        },

        updateProgram(obj) {
            this.is_user_filter=true;
            this.resetSort();
            this.programs.forEach(item => {
                item.is_selected = false;
                if (item.id === obj.id) {
                    item.is_selected = true;
                }
            });
    
            let selectedProgram = this.programs.find(program => program.is_selected);
            let selectedText = selectedProgram ? selectedProgram.text : null;
            if( selectedText!=='All' && selectedText ){
                this.filter_value[1].value=selectedText;
            }else{
                this.filter_value[1].value='';
            }
            this.fetchData();
        },

        updatePagenum(obj) {
            this.is_user_filter=true;
            this.sort.page=1;
            this.sort.per_page = obj.id;
            this.fetchData();
            // console.log(obj)
        },

        gotoPage(page) {
            this.sort.current_page = page;
            this.fetchData();
        },

        goOutsidePage(row){
            if(row.status === 100){
                window.open(row.url, "_blank")
            }
        },

        sortFun(key) {
            if (key === this.sort.sort_key) {
                this.sort.sort_val = this.sort.sort_val === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort.sort_key = key;
                this.sort.sort_val = 'asc';
            }
            this.sort.page =1;
            this.fetchData();
        },

        makeFilter(){
            let filter_val=[];
            let f1=this.filter_value[0];
            if(f1.value){
                filter_val.push({field_name:f1.field_name,value:f1.value})
            };

            let f2=this.filter_value[1];
            if(f2.value){
                filter_val.push({field_name:f2.field_name,value:f2.value})
            };

            let params_data = {
                page: this.sort.current_page,
                per_page:this.sort.per_page,
                keyword: this.sort.search_keyword,
                filters:JSON.stringify(filter_val),
            };

            if(this.sort.sort_key){
                params_data.sort_key=this.sort.sort_key;
                params_data.sort_val=this.sort.sort_val;
            }

            return params_data;
        },

        //get data
        fetchData() {
            if (!this.is_loading) this.is_loading_data = true;
            let api = '/ambassador/list';
            let params_data=this.makeFilter();

            this.data=[];
            this.$ajax(api, {
                params: params_data,
                method: 'get',
            }).then(res => {
                const statusMap = {
                    100: { text: 'Active', color: 'act', btn: 'Responses' },
                    80: { text: 'Scheduled', color: 'sch', btn: 'Responses' },
                    50: { text: 'Draft', color: 'dis', btn: 'Edit' },
                    0: { text: 'Closed', color: 'clo', btn: 'Responses' }
                };

                res.data.data.data.forEach(item => {
                    let appRate = HandleNumSpec(item.approved_rate) === '---' ? '' : `(${HandleNumSpec(item.approved_rate)}%)`;
                    item.list = [
                        { name: 'Approved', value: `${HandleNum(item.approved)} ${appRate}` },
                        { name: 'To-Do', value: HandleNum(item.todo) },
                        { name: 'Waitlist', value: HandleNum(item.waitlist) },
                        { name: 'Candidates', value: HandleNum(item.candidates), new: HandleNum(item.new_candidates)}
                    ];

                    const toSetDate=(start,end )=>{
                        let hsdate= start ==="0000-00-00 00:00:00" ? '' : moment(start).format('MM/DD/YY ');
                        let hedate= end ==="0000-00-00 00:00:00" ? '' : moment(end).format('MM/DD/YY ');
                        
                        if(item.status===100){
                            return `${!hsdate? moment(item.created_at).format('MM/DD/YY '): hsdate} - ${!hedate?'Open':hedate}`
                        }else{
                            return `${!hsdate? moment(item.created_at).format('MM/DD/YY '): hsdate} - ${hedate?hedate:'Open'}`
                        }
                    }

                    item.period = toSetDate(item.application_start,item.application_end);

                    const statusInfo = statusMap[item.status] || { text: '', color: '', btn: 'Responses' };
                    item.stateValue = { text: statusInfo.text, value: item.status, color: statusInfo.color };
                    item.btn = statusInfo.btn;
                    item.tag=item.program_tag;

                    this.data.push(item);
                });

                this.sort.total_page=res.data.data.last_page;
                this.is_user_filter=false;

                this.is_loading = false;
                this.is_loading_data = false;
                this.$store.state.is_loading=false;
            })
        },

        getTags() {
            this.programs=[{ id: 99999999, text: 'All', is_selected: true },];
            this.$ajax('/creator/get-tag-from-ambassador-list', {
                method: 'get',
                data:{
                    merchant_account_id:this.$store.state.user_data.merchant_account_id
                }
            }).then(res => {
                // console.log(res.data.data)
                res.data.data.forEach((item, index) => {
                    this.programs.push({ 
                        ...item,
                        text:item.tag,
                        is_selected: false,
                    });
                });
                
            });
        },

        createPro(){
            this.$refs.add.open();
        },

        goOpenSet(val){
            if(val.type==='create'){
                window.localStorage.setItem('ANCHOR_program_create_data', JSON.stringify(val.val));
                this.openFormSetting(val.val, val.type, 1);
            }
        }

    },

    created () {
        window.addEventListener('click', this.handleClick);
    },

    destroyed () {
        window.removeEventListener('click', this.handleClick);
    },


    mounted() {
        if(!this.permission_recruitment.manageApplications.permission){
            this.$router.push({ name: 'creator--list' });
            return;
        }
        window.localStorage.removeItem('ANCHOR_program_create_data');
        if (this.$store.state.is_show_share) {
            this.$store.state.is_show_share = false;
            this.$refs.share.open();
        }

    },

}
</script>

<style lang="scss">
@mixin flexCenter(){
    display: flex;
    align-items: center;
}

@mixin textOverflow(){
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}
.creator-list-content {
    &>.inner {
        height: 100%;
        padding: 24px 48px;
        display: grid;
        grid-template-rows: auto auto 1fr;
        grid-template-columns: 100%;
        overflow: hidden;
    }

    &>.inner-empty{
        padding: 24px 32px 24px 48px;
        grid-template-rows: auto 1fr;
    }

    .loading.static {
        margin-top: 48px;
    }

    .drop-box{
        @include flexCenter();
        margin:16px 0;

        h3{
            font:var(--font-med-20);
            @include flexCenter();
            margin-right:16px;
        }
    }

    .applic-data-wrap {
        height: 100%;
        max-height: calc(100vh - 144px);
        display: grid;
        grid-template-rows: auto auto 1fr;
        grid-template-columns: 100%;
        position: relative;

        .top {
            display: flex;
            align-items: center;
            padding: 16px 0;

            .ui-search {
                flex: 1;
                padding: 0 10px;

                .ui-search-input .input {
                    max-width: unset;
                }
            }

            .left {
                display: flex;
                align-items: center;

                .ui-button {
                    display: inline-flex;
                    align-items: center;

                    .svg-icon--plus {
                        height: 10px;
                        width: 10px;
                        margin-right: 5px;
                    }
                }

                .ui-dropdown,
                .ui-filter-dropdown {
                    margin-left: 10px;

                    &:first-child{
                        margin-left: 0;
                    }
                }
            }

            .right {
                display: flex;
                align-items: center;

                .ui-dropdown {
                    margin-right: 10px;
                }

                .download-btn {
                    color: var(--black-90);
                    height: 32px;
                    width: 32px;
                    margin-left: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    ;

                    svg {
                        height: 16px;
                        width: 16px;
                        display: block;
                    }

                    &.disabled {
                        cursor: not-allowed;

                        svg {
                            fill: var(--black-20);
                        }
                    }
                }
            }

            .ui-dropdown {
                .ui-button {
                    border-color: var(--black-10);
                    background-color: var(--black-10);
                }
            }
        }

        .editList {
            padding: 8px 0;
            width: max-content;
            background: white;
            border: 1px solid #F2F2F2;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            position: absolute;
            z-index: 9;
            right:0px;
            width:150px;

            .tit{
                padding: 0 9px;
                font:var(--font-med-12);
                color:var(--black-50);
            }

            .item {
                padding: 9px 10px;
                @include flexCenter();
                cursor: pointer;
                color: var(--black-90);
                font: unset;
                font-family: var(--font);
                font-size: 14px;

                &:hover {
                    background: var(--bg-02);
                }

                .red{
                    color:var(--red);
                }

            }
        }

        .dropdown-programs .ui-dropdown--inner {
            .ui-button span::before {
                content: 'Application Tag: ';
            }

            .scrollbar-content {
                min-width: 200px;
                max-height: 300px;

                &::before {
                    content: 'Application Tag: ';
                    display: block;
                    font: var(--font-regular-12);
                    padding: 6px 10px 0;
                    color: var(--black-50);
                    margin-bottom: 12px;
                }
            }
        }

        .dropdown-status .ui-dropdown--inner {
            .ui-button span::before {
                content: 'Status: ';
            }

            .scrollbar-content {
                max-height: 300px;

                &::before {
                    content: 'Status: ';
                    display: block;
                    font: var(--font-regular-12);
                    padding: 6px 10px 0;
                    color: var(--black-50);
                    margin-bottom: 12px;
                }
            }
        }

        .ui-table {
            white-space: nowrap;

            .tbody tr {
                cursor: pointer;

                &.status-draft {
                    cursor: default;
                }

                .td {
                    max-width: 250px;
                    @include textOverflow;
                }

                .none {
                    color: var(--neutral-60);
                }

                .tag-td{
                    //max-width: 120px;
                    .my-badges-iden{
                        @include textOverflow;
                        max-width: 120px;
                        width: auto;
                    }
                }

                .name{
                    .title{
                        font:var(--font-med-16);
                        margin-bottom:3px;
                    }

                    a{
                        color:var(--blue);
                        font-size:12px;
                    }
                }

                .badage{
                    .my-badges-iden{
                        font:var(--font-med-10);
                    }
                }

                .value{
                    .v-title{
                        font-size:14px;
                        color:var(--black-75);
                        margin-bottom:3px;
                    }

                    .v-value{
                        font:var(--font-med-12);
                        @include flexCenter();
                        justify-content: space-between;
                    }

                    .v-is-new{
                        background: var(--red);
                        border-radius: 10px;
                        @include flexCenter();
                        color: var(--white);
                        padding: 0 6px;
                        height: 18px;
                        font-size: 10px;
                        margin-left: 6px;

                        .svg-icon{
                            width: 6px;
                            height: 6px;
                            margin-right: 2px;
                            fill: var(--white);
                        }
                    }
                }

                .item-btn{

                    .ui-button{
                        display: block;
                        padding:6px 8px;
                        height: unset;
                        box-sizing: border-box;
                        width: 100%;
                        text-align: center;

                        &:hover {
                            background: var(--bg-02);
                        }
                    }
                }


                svg {
                    height: 12px;
                    display: block;
                    width: 12px;
                }

                .three-td{
                    position: relative;
                    overflow: unset
                }
            }

            .text-ellipsis-link:hover {
                text-decoration: underline;
            }


        }

    }

    .data-list-open-scroll{
        height: 90vh;
        overflow-y: visible;
    }

}

.creator-modal {
    z-index: 999;
}

.add-creator-modal-box {
    padding: 24px;
    display: flex;
    align-items: flex-start;
}
</style>